import { useState } from 'react';
import { supabase } from '../utils/supabase';

export default function Login() {
  const [mode, setMode] = useState('select'); // select, email
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const signInMicrosoft = async () => {
    await supabase.auth.signInWithOAuth({
      provider: 'azure',
      options: { scopes: 'email profile', redirectTo: window.location.origin },
    });
  };

  const signInEmail = async () => {
    setLoading(true);
    setError('');
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) setError(error.message);
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4">
      <div className="text-center max-w-sm w-full">
        <img src="https://static.wixstatic.com/media/cf458d_f7329a8f179a4571a1951c4ed9431604~mv2.png" alt="NEG" className="h-12 mx-auto mb-6" />
        <h1 className="font-display text-3xl text-brand-gold mb-2">Beverage Collective</h1>
        <p className="text-neutral-500 text-sm mb-8">Category Support Platform</p>

        {mode === 'select' && (
          <div className="space-y-3">
            <button onClick={signInMicrosoft} className="btn-primary w-full text-sm py-4">
              NEGroup Team — Sign In with Microsoft
            </button>
            <button onClick={() => setMode('email')} className="btn-secondary w-full text-sm py-4">
              Supplier / Operator — Sign In with Email
            </button>
          </div>
        )}

        {mode === 'email' && (
          <div className="space-y-3">
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="Email address"
              className="input-field text-sm"
            />
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Password"
              className="input-field text-sm"
              onKeyDown={e => e.key === 'Enter' && signInEmail()}
            />
            {error && <p className="text-red-400 text-xs">{error}</p>}
            <button onClick={signInEmail} disabled={loading} className="btn-primary w-full text-sm py-3 disabled:opacity-50">
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
            <button onClick={() => { setMode('select'); setError(''); }} className="btn-ghost text-xs w-full">
              ← Back
            </button>
          </div>
        )}

        <p className="text-neutral-700 text-xs mt-6">Next Experience Group — Beverage Collective</p>
      </div>
    </div>
  );
}
